import React, { useState } from 'react';
import PropTypes from 'prop-types';

const FormInput = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  required = false,
  disabled = false,
  error = '',
  className = '',
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div className="input-wrapper">
      {label && (
        <label htmlFor={name} className="input-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}

      <input
        id={name}
        name={name}
        type={inputType}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`form_input ${error ? 'input-error' : ''} ${className}`}
        {...props}
      />
      {isPassword && value && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="eye_button"
        >
          <i
            className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
            title={showPassword ? 'Hide Password' : 'Show Password'}
          ></i>
        </button>
      )}

      {error && <div className="input-error-message">{error}</div>}
    </div>
  );
};

FormInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
};

export default FormInput;
